// Login actions
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const REFRESH_TOKEN_FAIL = "REFRESH_TOKEN_FAIL";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const NOSAVE = "NOSAVE";
